"use client";
import React from "react";
import Card from "../primitives/card";
import { ALL_SPORT_OPTIONS } from "@/utils/sports";
import { ALL_ODD_OPTIONS } from "@/data/sports/options";
import PickHistoryTable from "./pick-history-table";
import NotFound from "../primitives/not-found";
import Select from "../primitives/select";
import {
  BettorHistoricalPicks,
  OddVariant,
  Sport,
} from "common";
import { useRouter } from "next-nprogress-bar";
import { useQueryUpdater } from "@/utils/hooks/navigation";

export interface PickHistorySearchParams {
  limit?: "10" | "25" | "50" | "100";
  page?: number;
  sport?: Sport;
  odd?: OddVariant;
}
export default function PickHistory({
  data,
  searchParams,
}: {
  data: BettorHistoricalPicks | null;
  searchParams: PickHistorySearchParams
}) {

  const router = useRouter();
  const { createQueryParamString } = useQueryUpdater();

  const onPageChange = (newPage: number) => {
    router.replace(createQueryParamString("page", newPage.toString()), {
      scroll: false,
    });
  };

  const onPageSizeChange = (newSize: number) => {
    router.replace(createQueryParamString("limit", newSize.toString()), {
      scroll: false,
    });
  };

  const onSportChange = (v: string) => {
    router.replace(createQueryParamString("sport", v), {
      scroll: false,
    });
  };

  const onOddChange = (v: string) => {
    router.replace(createQueryParamString("odd", v), {
      scroll: false,
    });
  };

  return (
    <Card.Group>
      <Card
        header={{
          title: "Pick History",
          action: (
            <div className="flex gap-4">
              <Select
                options={ALL_SPORT_OPTIONS}
                value={searchParams.sport || "all-sports"}
                onValueChange={onSportChange}
                label="Sports"
                variant="card"
              />
              <Select
                options={ALL_ODD_OPTIONS}
                value={searchParams.odd || "all"}
                onValueChange={onOddChange}
                label="Odds"
                neutral
                variant="card"
              />
            </div>
          ),
        }}
      >
        <PickHistoryTable
          data={(data === null || data?.picks === null || data?.picks.length === 0) ? undefined : data?.picks}
          // error={isError}
          fallback={
            <div className="h-96">
              <NotFound
                label="no picks found"
                icon="ticket-buy"
                caption="Picks of concluded games will appear here."
              />
            </div>
          }
          pagination={{
            size: Number(searchParams.limit || 10),
            page: Number(searchParams.page || 1),
            count: data?.pagination.totalCount || 0,
            onPageChange: onPageChange,
            onPageSizeChange: onPageSizeChange,
          }}
        />
      </Card>
      <div className="bg-surface rounded-lg w-full p-8 flex flex-col gap-4">
        <div className="text-label-lg-bold uppercase text-secondary">
          Glossary
        </div>
        <div className="flex flex-row flex-wrap text-title-sm text-secondary-300 gap-y-4 py-4 whitespace-nowrap gap-4">
          <div className="flex basis-3/12">
            <span className="font-medium">W:</span>&nbsp;<span>Win</span>
          </div>
          <div className="flex basis-3/12">
            <span className="font-medium">L:</span>&nbsp;<span>Loss</span>
          </div>
          <div className="flex basis-3/12">
            <span className="font-medium">P:</span>&nbsp;<span>Push</span>
          </div>
          <div className="flex basis-3/12">
            <span className="font-medium">PP:</span>&nbsp;
            <span>Postponed Game</span>
          </div>
          <div className="flex basis-3/12">
            <span className="font-medium">C:</span>&nbsp;
            <span>Canceled Game</span>
          </div>
        </div>
      </div>
    </Card.Group>
  );
}
